"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapOptionsToQueryParams = void 0;
var tslib_1 = require("tslib");
var common_1 = require("@wix/wix-vod-constants/common");
var video_types_1 = require("./video.types");
var api_types_1 = require("@wix/wix-vod-constants/api-types");
var DEFAULT_PAGING = {
    size: 30,
    cursor: null,
};
var DEFAULT_SORT = {
    order: api_types_1.SortOrders.Custom,
    direction: api_types_1.SortDirections.Ascending,
};
var mapOptionsToQueryParams = function (_a) {
    var _b;
    var query = _a.query, tag = _a.tag, category = _a.category, _c = _a.mediaType, mediaType = _c === void 0 ? common_1.MEDIA_TYPES.SECURE_VIDEO : _c, sort = _a.sort, paging = _a.paging, itemType = _a.itemType, templateMetaSiteId = _a.templateMetaSiteId, withPlayInfo = _a.withPlayInfo;
    var sortWithDefaults = tslib_1.__assign(tslib_1.__assign({}, DEFAULT_SORT), sort);
    var pagingWithDefaults = tslib_1.__assign(tslib_1.__assign({}, DEFAULT_PAGING), paging);
    var reversedOrderMapping = (_b = {},
        _b[api_types_1.SortOrders.Custom] = video_types_1.ReversedSortOrders.ReverseCustom,
        _b[api_types_1.SortOrders.Name] = video_types_1.ReversedSortOrders.ReverseName,
        _b[api_types_1.SortOrders.Relevance] = video_types_1.ReversedSortOrders.ReverseRelevance,
        _b[api_types_1.SortOrders.Date] = video_types_1.ReversedSortOrders.ReverseDate,
        _b);
    var params = {
        metaSiteId: templateMetaSiteId,
        query: query,
        tag: tag,
        category: category,
        media_type: mediaType,
        page_size: pagingWithDefaults.size,
        item_type: itemType,
        cursor: pagingWithDefaults.cursor,
        order: sortWithDefaults.direction === api_types_1.SortDirections.Descending &&
            reversedOrderMapping[sortWithDefaults.order]
            ? reversedOrderMapping[sortWithDefaults.order]
            : sortWithDefaults.order,
    };
    if (withPlayInfo) {
        params.with_play_info = true;
    }
    return params;
};
exports.mapOptionsToQueryParams = mapOptionsToQueryParams;
//# sourceMappingURL=video.utils.js.map